module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/177.d2137c98.png";